/* globals jQuery */

// import 'typeface-source-sans-pro'
// import '@app/less/bootstrap-app-custom.less'

// Versión 5 de font-awesome
import "../../node_modules/@fortawesome/fontawesome-free/css/all.min.css";
// Upgrade a versión 5
import "../../node_modules/@fortawesome/fontawesome-free/css/v4-shims.min.css";

import "../../node_modules/animate.css/animate.compat.css";
import Swal from "sweetalert2";

export const init = () => {
  console.debug("init custom bootstrap");

  const swalError = (message: string) => {
    Swal.fire({
      html: message,
      icon: "error",
    });
  };

  const swalSuccess = (message: string) => {
    Swal.fire({
      html: message,
      icon: "success",
    });
  };

  const swalWarning = (message: string) => {
    Swal.fire({
      html: message,
      icon: "warning",
    });
  };

  const swalConfirm = (message: string, confirmCallback: () => void) => {
    Swal.fire({
      html: message,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Si, Confirmar",
      cancelButtonText: "No, Cancelar",
    }).then((result) => {
      if (result.value) {
        confirmCallback();
      }
    });
  };

  jQuery(window).on("load", () => {
    jQuery("#cover").fadeOut(100);
    setTimeout(() => {
      jQuery("#cover").fadeOut(100);
    }, 2000);
  });

  jQuery(function($) {
    $('[data-toggle="tooltip"]').tooltip();

    if ($().popover) {
      //@ts-ignore
      window.closeAppPopOver = (element) => {
        $(element).closest("div.popover").popover("hide");
      };
      const popOverSettings = {
        selector: ".ajax-popover",
        html: true,
        sanitize: false,
        container: "body",
        delay: { show: 500, hide: 1000 },
        trigger: "hover click",
        template:
          '<div class="popover" role="tooltip" style="max-width:400px;"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>',
        placement: "auto",
        title: function() {
          return '&nbsp;<a onclick="closeAppPopOver(this)" class="close">&times;</a>';
        },
        content: function() {
          const $this = $(this);
          return $.ajax({
            url: $this.data().url,
            accepts: {
              html: "text/partial+html",
            },
            dataType: "html",
            async: false,
          }).responseText;
        },
      };

      //@ts-ignore
      $("body").popover(popOverSettings);
    }

    $(document).on("submit", ".form-ajax", function() {
      const $this = $(this);
      const data = $this.data();
      const url = $this.attr("action");

      const method = data.method ? data.method : "post";
      const datatype = data.datatype ? data.datatype : "json";

      if ((data.confirm && confirm(data.confirm)) || !data.confirm) {
        if (data.target) {
          $(data.target)
            .find(".modal-body")
            .prepend(
              "<div class='well well-lg text-center'><i class='fa fa-refresh fa-spin fa-5x fa-fw'></i></div>",
            )
            .children()
            .eq(1)
            .hide();
        }
        if (data.output) {
          $(data.output).html("<i class='fa fa-refresh fa-spin fa-fw'></i>");
        }

        console.debug("form-ajax [method:url] : " + method + ":" + url);

        $.ajax({
          url: url,
          type: method,
          data: $this.serialize(),
          dataType: datatype,
          success: function(result) {
            let message = "";
            if (datatype === "json") {
              message = result.message;
            } else {
              message = result;
            }

            if (data.output) {
              $(data.output).html(message);
            } else if (data.target) {
              $(data.target).find(".modal-body").html(message);
            } else {
              swalSuccess(message);
            }

            if (data.reload === true) {
              window.location.reload();
            }
          },
          error: function(e) {
            swalError(e.status + " " + e.statusText + ": " + e.responseText);
          },
        });
      }

      return false;
    });

    $(document).on("click", ".btn-ajax:not([disabled])", function(event) {
      event.preventDefault();
      const $this = $(this);
      const data = $this.data();

      const method = data.method ? data.method : "get";
      const datatype = data.type ? data.type : "json";

      let makeRequest = () => {
        if (data.target) {
          $(data.target)
            .find(".modal-body")
            .html(
              "<div class='well well-lg text-center'><i class='fa fa-refresh fa-spin fa-5x fa-fw'></i></div>",
            );
        }
        if (data.output) {
          $(data.output).html("<i class='fa fa-refresh fa-spin fa-fw'></i>");
        }

        $(".navbar-brand").addClass("animated zoomIn infinite");

        console.debug("btn-ajax [method and url]:", method + ":" + data.url);
        console.debug("btn-ajax [datatype]:", datatype);

        $.ajax({
          url: data.url,
          type: method,
          data: data,
          dataType: datatype,
          success: function(result) {
            $(".navbar-brand").removeClass("animated infinite");
            let messages: string[] = [];
            if (datatype === "json") {
              if (result.errors) {
                messages = messages.concat(result.errors);
              }
              if (result.messages) {
                messages = messages.concat(result.messages);
              }
              if (result.message) {
                messages.push(result.message);
              }
            } else {
              messages.push(result);
            }

            if (data.output) {
              $(data.output).html(messages.join("<br>"));
            } else if (data.target) {
              $(data.target).find(".modal-body").html(messages.join("<br>"));
            } else {
              if (result.error) {
                swalError(result.errors.join("\n"));
              } else {
                let message = messages.join("\n");

                if (data.reload === true) {
                  message += "\n\nRecargando la pagina en 5 segundos.";
                  setTimeout(() => {
                    window.location.reload();
                  }, 5000);
                }

                swalSuccess(message);
              }
            }
          },

          error: (e) => {
            $(".navbar-brand").removeClass("animated infinite");

            if (!e.responseText) {
              return swalWarning(
                `Respuesta del servidor vacia. Código de error:  ${e.status}`,
              );
            }

            if (datatype !== "json") {
              return swalError(e.responseText);
            }

            const responseJSON = $.parseJSON(e.responseText);
            if (responseJSON.error) {
              return swalError(
                e.status +
                " " +
                e.statusText +
                "\n\n" +
                responseJSON.errors.join("\n\n"),
              );
            }

            swalError(e.status + " " + e.statusText + ": " + e.responseText);
          },
        });
      };

      if (data.confirm) {
        return swalConfirm(data.confirm, makeRequest);
      }

      return makeRequest();
    });
  });
};
